import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { userSiteActions } from 'pages/dashboard/containers/sites/actions/userSites';
import { checkUserPanelAccess } from 'helpers/dashboard';
import { Button } from 'react-bootstrap';
import { getOrganization } from 'selectors';
import { BILLING_PAGE } from 'components/ctaBanner/constants';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { handleNavigateInsightPage } from 'helpers/dashboard';

const moment = require('moment');

const UserSite = (props) => {
  const { site, userSelectedSite, dispatch, currentPlan, renewalExpiry, useSiteLength } = props;
  const history = useHistory();
  const selected = userSelectedSite.includes(site.slug);

  const handleNavigate = async (event) => {
    event.stopPropagation();
    handleNavigateInsightPage(dispatch, site, history, useSiteLength);
  };

  const dayRemainings = 30 - new moment().diff(renewalExpiry, 'days');
  const checkDeactivatedSite = site.slug !== 'all' && ['trial', 'deactivated'].includes(currentPlan);
  const handleSelectedSites = (event) => {
    if (checkUserPanelAccess(site.user_panel_role)) {
      dispatch(
        userSiteActions.UpdateSelectedSites({
          removedSelectedSite: userSelectedSite.includes(site.slug),
          data: site.slug
        })
      );
    }
  };

  return (
    <div
      className={`slide-card ${selected ? 'card-selected' : ''} ${
        site.user_panel_role === 'panel_user' ? 'slide-card-role' : ''
      }`}
      onClick={handleSelectedSites}
    >
      <div className="card-text">
        <div className="site-name">
          <div>
            <h2 className="site-title" style={{ margin: `${checkDeactivatedSite ? '0px' : ''}` }}>
              {site.slug}
              {site.slug !== 'all' && ['deactivated'].includes(currentPlan) && (
                <small className="d-block text-error pt-2" style={{ fontSize: '0.75rem' }}>
                  limited access
                </small>
              )}
            </h2>
          </div>
        </div>
        {site.slug !== 'all' &&
          (!['deactivated'].includes(currentPlan) ? (
            <Button className="p-0" variant="link" onClick={handleNavigate}>
              view site panel
            </Button>
          ) : (
            <small className="pt-2 text-error d-block">
              Your site with complete data will be removed{' '}
              {`${dayRemainings > 0 ? `in ${dayRemainings} days` : 'today'}`},{' '}
              <Link className="alert-link mt-2 mt-lg-0" to={BILLING_PAGE}>
                Activate billing{' '}
              </Link>
              to save site
            </small>
          ))}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const { current_site_plan, renewal_expiry } = getOrganization(state);
  const useSiteLength = state.USER_SITES.user_site?.length || 0;

  return {
    userSelectedSite: state.USER_SITES.selected_sites,
    currentPlan: current_site_plan,
    renewalExpiry: renewal_expiry,
    useSiteLength: useSiteLength
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

const connectedUserSite = connect(mapStateToProps, mapDispatchToProps)(UserSite);
export default connectedUserSite;
